'use strict';

var Day = require('./Day');
var modulo = require('./modulo');

// https://262.ecma-international.org/5.1/#sec-15.9.1.6

module.exports = function WeekDay(t) {
	return modulo(Day(t) + 4, 7);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/WeekDay.js
// module id = 1336
// module chunks = 0